import {
    GA_FILTERS_CATEGORY,
    GA_FILTER_CLEAR_ONE_LABEL,
    GA_FILTER_CLEAR_ACTION
} from '@common/Tracking';
import { pushGAEventToDataLayer } from '@helpers/dataLayer';
import {
    STORE_AVAILABLE_FILTERS,
    STORE_DROPDOWN_FILTERS,
    STORE_GENDER_FILTER,
    STORE_AGE_FILTER,
    UPDATE_ACTIVE_FILTERS,
    DESELECT_ALL_FILTERS,
    STORE_PERSONAL_CATEGORY,
    BULK_UPDATE_ACTIVE_FILTERS,
    ADD_PERSONAL_CATEGORY,
    REMOVE_PERSONAL_CATEGORY,
    REMOVE_FILTERS_BY_TYPE,
    SET_ACTIVE_FILTER_BY_TYPE,
    SET_ACTIVE_FILTERS
} from '../actions/actionTypes';

const initialState = {
    availableFilters: {},
    dropdownFilters: {},
    activeFilters: [],
    genderFilter: [],
    ageFilter: [],
    personalCategory: []
};

export default function reducers(state = initialState, action) {
    const { payload } = action;

    switch (action.type) {
        case STORE_AVAILABLE_FILTERS:
            return { ...state, availableFilters: action.payload };
        case STORE_DROPDOWN_FILTERS:
            return { ...state, dropdownFilters: action.payload };
        case STORE_GENDER_FILTER:
            return { ...state, genderFilter: action.payload };
        case STORE_AGE_FILTER:
            return { ...state, ageFilter: action.payload };

        case REMOVE_FILTERS_BY_TYPE: {
            return {
                ...state,
                activeFilters: state.activeFilters.filter(({ filterType }) => filterType !== payload)
            };
        }

        case UPDATE_ACTIVE_FILTERS: {
            const isActiveFilter = state.activeFilters.some(
                elem => elem.filterType === action.payload.filterType && elem.value === action.payload.value
            );

            const newActiveFilters = isActiveFilter
                ? state.activeFilters.filter(activeFilter => (activeFilter.value !== action.payload.value))
                : [...state.activeFilters, action.payload];

            const GAEventAttributes = isActiveFilter
                ? [GA_FILTERS_CATEGORY, GA_FILTER_CLEAR_ACTION, GA_FILTER_CLEAR_ONE_LABEL]
                : [
                    GA_FILTERS_CATEGORY,
                    action.payload.filterType,
                    action.payload.trackingName ? action.payload.trackingName : action.payload.name
                ];

            pushGAEventToDataLayer(...GAEventAttributes);
            return { ...state, activeFilters: newActiveFilters };
        }

        case BULK_UPDATE_ACTIVE_FILTERS: {
            let myActiveFilters = [...state.activeFilters];

            action.payload.filters.forEach((filterItem) => {
                const isActive = state.activeFilters.some(elem => (
                    elem.filterType === filterItem.filterType && elem.value === filterItem.value
                ));

                if (!action.payload.toggle) {
                    if (!isActive) {
                        myActiveFilters = [...myActiveFilters, filterItem];
                    }
                } else if (isActive) {
                    myActiveFilters = myActiveFilters.filter(activeFilter => (activeFilter.value !== filterItem.value));
                }

                const GAEventAttributes = isActive
                    ? [GA_FILTERS_CATEGORY, GA_FILTER_CLEAR_ACTION, GA_FILTER_CLEAR_ONE_LABEL]
                    : [
                        GA_FILTERS_CATEGORY,
                        filterItem.filterType,
                        filterItem.trackingName ? filterItem.trackingName : filterItem.name
                    ];
                pushGAEventToDataLayer(...GAEventAttributes);
            });

            return { ...state, activeFilters: myActiveFilters };
        }

        case DESELECT_ALL_FILTERS: {
            const filtersToSkip = ['age'];
            const myActiveFilters = state.activeFilters.filter(activeFilter => filtersToSkip.includes(activeFilter.filterType));
            return { ...state, activeFilters: myActiveFilters };
        }

        case ADD_PERSONAL_CATEGORY: {
            if (!state.activeFilters.some(elem => elem.filterType === 'personalcategory')) {
                return {
                    ...state,
                    activeFilters: [
                        ...state.activeFilters,
                        { value: '1', name: 'on', filterType: 'personalcategory' }
                    ]
                };
            }

            return state;
        }

        case REMOVE_PERSONAL_CATEGORY: {
            if (!state.activeFilters.some(elem => elem.filterType === 'personalcategory')) {
                return state;
            }

            return {
                ...state,
                activeFilters: state.activeFilters.filter(filterItem => filterItem.filterType !== 'personalcategory')
            };
        }

        case STORE_PERSONAL_CATEGORY:
            return { ...state, personalCategory: action.payload };

        case SET_ACTIVE_FILTER_BY_TYPE: {
            const activeFilters = state.activeFilters.filter(({ filterType }) => filterType !== payload.filterType);

            activeFilters.push(payload);

            return {
                ...state,
                activeFilters
            };
        }

        case SET_ACTIVE_FILTERS: {
            return {
                ...state,
                activeFilters: action.payload
            };
        }

        default:
            return state;
    }
}
